import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "routinecalendar",
  "use": "routinecalendar-usage",
  "viewBox": "0 0 17.19 19.5",
  "content": "<symbol viewBox=\"0 0 17.19 19.5\" id=\"routinecalendar\"><defs><clipPath id=\"routinecalendar_a\"><path fill=\"none\" d=\"M0 0h17.19v19.5H0z\" /></clipPath></defs><g clip-path=\"url(#routinecalendar_a)\"><path d=\"M14.06 17.88h1.57v-1.63h-1.57zm0-3.25h1.57V13h-1.57zm0-3.25h1.57V9.75h-1.57zm-3.12 6.5h1.56v-1.63h-1.56zm0-3.25h1.56V13h-1.56zm0-3.25h1.56V9.75h-1.56zm-3.13 6.5h1.56v-1.63H7.81zm0-3.25h1.56V13H7.81zm0-3.25h1.56V9.75H7.81zm-3.12 6.5h1.56v-1.63H4.69zm0-3.25h1.56V13H4.69zm0-3.25h1.56V9.75H4.69zm-3.13 6.5h1.56v-1.63H1.56zm0-3.25h1.56V13H1.56zm0-3.25h1.56V9.75H1.56zM17.19 6.5v12.19a.85.85 0 0 1-.23.57.72.72 0 0 1-.55.24H.78a.72.72 0 0 1-.55-.24.85.85 0 0 1-.23-.57V6.5zM0 4.88V2.44a.82.82 0 0 1 .23-.58.71.71 0 0 1 .55-.23h2.35V0h1.56v1.63h7.81V0h1.56v1.63h2.35a.71.71 0 0 1 .55.23.82.82 0 0 1 .23.58v2.44z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/routinecalendar.svg
// module id = Gx0O
// module chunks = 1